"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.avatar.exceeded': 'Osiągnięto limit awatarów. Ulepsz swój plan, aby utworzyć więcej awatarów.',
    'limits.avatar.limitReached': 'Limit awatarów: {limit} (ulepsz dla więcej)',
};
